import { labelById } from "../../../../Components/Molecules/GridHistory/gridFilterUtils";

export const BAAS_CURRENCIES = [
  { id: "BRL", label: "BRL" },
  { id: "USD", label: "USD" },
  { id: "USDC", label: "USDC" },
  { id: "EUR", label: "EUR" },
];

export const EMPTY_BAAS_CURRENCY_FILTERS = {
  currencies: [],
  searchQuery: "",
};

export const hasActiveBaasCurrencyFilters = (filters) =>
  filters.currencies.length > 0 || Boolean(filters.searchQuery?.trim());

export const isBaasCurrencyChipFilterActive = (filters, chipId) => {
  switch (chipId) {
    case "currency":
    case "more":
      return filters.currencies.length > 0;
    default:
      return false;
  }
};

export const buildBaasCurrencyFilterTags = (filters) => {
  const tags = [];

  if (filters.searchQuery?.trim()) {
    tags.push({
      key: "searchQuery",
      iconType: "search",
      value: filters.searchQuery.trim(),
    });
  }

  if (filters.currencies.length > 0) {
    tags.push({
      key: "currencies",
      iconType: "currency",
      value: filters.currencies
        .map((currency) => labelById(BAAS_CURRENCIES, currency))
        .join(", "),
    });
  }

  return tags;
};

export const removeBaasCurrencyFilterTag = (filters, tagKey) => {
  switch (tagKey) {
    case "currencies":
      return { ...filters, currencies: [] };
    case "searchQuery":
      return { ...filters, searchQuery: "" };
    default:
      return filters;
  }
};

const filterBalancesByCurrency = (balances = [], currencies = []) => {
  if (!currencies.length) return balances;
  const selected = new Set(currencies.map((currency) => String(currency).toUpperCase()));
  return balances.filter((balance) =>
    selected.has(String(balance.currency || "").toUpperCase()),
  );
};

const accountMatchesSearch = (account, query) => {
  if (!query) return true;
  const currencyCodes = (account?.balances ?? [])
    .map((balance) => balance.currency)
    .filter(Boolean)
    .join(" ");
  const haystack = [account?.id, account?.label, account?.type, currencyCodes]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  return haystack.includes(query);
};

/** Resolve which currency the Resumo KPI cards should use. */
export const getBaasDisplayCurrency = (hierarchy, filters) => {
  if (filters.currencies.length > 0) {
    return String(filters.currencies[0]).toUpperCase();
  }

  const rootBalances = hierarchy?.rootAccount?.balances ?? [];
  const brl = rootBalances.find(
    (balance) => String(balance.currency || "").toUpperCase() === "BRL",
  );
  if (brl) return "BRL";
  return String(rootBalances[0]?.currency || "BRL").toUpperCase();
};

/**
 * Apply currency / search filters to the account hierarchy shown on Início.
 * - Moeda: keeps only selected currency rows on each account
 * - Busca: matches account id/label/type or currency codes
 */
export const applyBaasCurrencyFilters = (hierarchy, filters) => {
  if (!hierarchy?.rootAccount) return hierarchy;
  if (!hasActiveBaasCurrencyFilters(filters)) return hierarchy;

  const query = filters.searchQuery?.trim().toLowerCase() || "";

  const mapBalances = (account) => ({
    ...account,
    balances: filterBalancesByCurrency(account.balances, filters.currencies),
  });

  const rootAccount = mapBalances(hierarchy.rootAccount);
  let subAccounts = (hierarchy.subAccounts ?? []).map(mapBalances);

  if (query) {
    const rootMatches = accountMatchesSearch(hierarchy.rootAccount, query);
    subAccounts = subAccounts.filter((account) =>
      accountMatchesSearch(account, query),
    );

    if (!rootMatches && subAccounts.length === 0) {
      return {
        ...hierarchy,
        rootAccount: { ...rootAccount, balances: [] },
        subAccounts: [],
      };
    }

    return {
      ...hierarchy,
      rootAccount: rootMatches ? rootAccount : { ...rootAccount, balances: [] },
      subAccounts,
    };
  }

  return {
    ...hierarchy,
    rootAccount,
    subAccounts,
  };
};